import styled from 'styled-components';

export const Wrapper = styled.div`
	background-color: #ffffff;
	padding: 10px;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;
`;

export const TextContainer = styled.div`
	font-weight: 500;
	margin-top: 20px;
`;

export const TableHeading = styled.div`
	font-size: 14px;
`;
